import { reportErrorReason } from "../helpers/general-helpers";
var ProfilesToGroups = /** @class */ (function () {
    function ProfilesToGroups() {
        this.id = 'profiles_to_groups';
        this.alias = 'Customer Profiles to Customer Groups';
    }
    ProfilesToGroups.prototype.getData = function (connector, table, done) {
        connector
            .getApiClient()
            .fetchCustomerProfiles()
            .then(function (response) { return response.json(); })
            .then(function (data) {
            var rows = [];
            var profiles = data.data || [];
            profiles.forEach(function (profile) {
                var groups = profile.groups || [];
                var customerProfileId = profile.customer_profile_id;
                groups.forEach(function (groupId) {
                    rows.push({ customer_profile_id: customerProfileId, group_id: groupId });
                });
            });
            table.appendRows(rows);
        })
            .then(done)
            .catch(function (reason) { return reportErrorReason(reason, connector.getTableau()); });
    };
    ProfilesToGroups.prototype.getTableInfo = function () {
        return {
            id: this.id,
            alias: this.alias,
            columns: [
                {
                    id: 'customer_profile_id',
                    dataType: 'int',
                    alias: 'Customer Profile ID',
                    description: 'The customer profile ID used by Sprout to identify this social network profile.',
                },
                {
                    id: 'group_id',
                    dataType: 'int',
                    alias: 'Group ID',
                    description: 'The ID used by Sprout to identify this group.',
                },
            ],
        };
    };
    return ProfilesToGroups;
}());
export default ProfilesToGroups;
